import {
  GET_CMS_PAGE_DETAIL_FAIL,
  GET_CMS_PAGE_DETAIL_REQUEST,
  GET_CMS_PAGE_DETAIL_SUCCESS,
  GET_CMS_PAGE_LIST_FAIL,
  GET_CMS_PAGE_LIST_REQUEST,
  GET_CMS_PAGE_LIST_SUCCESS,
  POST_CMS_PAGE_CREATE_FAIL,
  POST_CMS_PAGE_CREATE_REQUEST,
  POST_CMS_PAGE_CREATE_SUCCESS,
} from "../../Constants/CmsConstants";

const initialStateDefault = {
  status: false,
  data: null,
  loading: true,
  error: null,
};

export const CmsPageListReducer = (state = initialStateDefault, action: any) => {
  try {
    if (action.type === GET_CMS_PAGE_LIST_REQUEST) {
      return { ...state, loading: true };
    }
    if (action.type === GET_CMS_PAGE_LIST_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === GET_CMS_PAGE_LIST_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const CmsPageDetailReducer = (state = initialStateDefault, action: any) => {
  try {
    if (action.type === GET_CMS_PAGE_DETAIL_REQUEST) {
      return { ...state, loading: true, data: null, status: false };
    }
    if (action.type === GET_CMS_PAGE_DETAIL_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === GET_CMS_PAGE_DETAIL_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const CmsPageCreateReducer = (state = initialStateDefault, action: any) => {
  try {
    if (action.type === POST_CMS_PAGE_CREATE_REQUEST) {
      return { ...state, loading: true };
    }
    if (action.type === POST_CMS_PAGE_CREATE_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === POST_CMS_PAGE_CREATE_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};
